import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {FciErrorType, FciErrorTypeHelper} from '@shared/models/fci-error-type';
import {HttpErrorService} from '@core/services/http-error.service';
import {log} from '@angular-devkit/build-angular/src/builders/ssr-dev-server';

@Injectable({providedIn: 'root'})
export class HttpErrorHandlerService implements HttpInterceptor {

	constructor(
		private httpErrorService: HttpErrorService
	) {
	}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			tap(() => {
				},
				(error: any) => {
					if (error instanceof HttpErrorResponse) {

						const headerValue = request.headers.get('X-FCI-ErrorType') ?? '';
						const fciErrorType = FciErrorTypeHelper.stringToEnum(headerValue);

						if (fciErrorType === FciErrorType.convenience || fciErrorType === FciErrorType.transparentSubstitution) {
							return;
						}

						// Temporary fix:
						// 1. User clicks log-out button and go to /account/signout?returnUrl=CURRENT_URL
						// 2. /account/signout logs out user and makes redirect to the CURRENT_URL
						// 3. Angular APP sees that CURRENT_URL is for logged-In users only and make redirect to sign-in page
						// 4. In that moment Firefox cancels the load of resources and throws NS_BINDING_ABORTED error
						// 5. User sees error popup
						// Permanent solution is to move canActivate checks to the server side
						if (error.url?.indexOf('/assets/i18n/') !== -1) {
							return;
						}

						this.httpErrorService.show$.next();
					}
				}));
	}
}
